import React from "react";
import { Location } from "@navigation/Location";
import { AccommodationRequestViewPage } from "../AccommodationRequest/AccommodationRequestViewPage";

type Params = {
  requestId: string;
};

export class AccommodationRequestViewLocation extends Location<Params> {
  render() {
    return (
      <AccommodationRequestViewPage
        requestId={this.params.requestId}
        onClose={() => this.navigation.close()}
      />
    );
  }

  equals(location: Location<Params>): boolean {
    return this.params.requestId === location.params.requestId;
  }

  toURI(): string {
    return `/bookings/accommodation-request/${this.params.requestId}/view`;
  }
}
